export const generateSaveTaskPayload = ({ formState, saveAsDraft, }) => ({
    title: {
        de: formState.titleTranslations.de,
        en: formState.titleTranslations.en,
        cs: formState.titleTranslations.cs,
    },
    ...(formState.internalTitle ? { internalTitle: formState.internalTitle } : {}),
    taskType: formState.selectedTaskType === 'location'
        ? 'check-in'
        : formState.selectedTaskType === 'info'
            ? 'information'
            : 'action',
    ...(formState.selectedTaskType === 'info'
        ? {}
        : { answerType: formState.selectedTaskType }),
    description: {
        de: formState.descriptionTranslations.de,
        en: formState.descriptionTranslations.en,
        cs: formState.descriptionTranslations.cs,
    },
    ...(formState.fileReference ? { fileReference: formState.fileReference } : {}),
    ...(formState.successPoints ? { successPoints: formState.successPoints } : {}),
    ...(formState.failurePoints ? { failurePoints: formState.failurePoints } : {}),
    ...(formState.selectedTaskType === 'location' && formState.coordinatesLat
        ? { coordinatesLat: +formState.coordinatesLat }
        : {}),
    ...(formState.selectedTaskType === 'location' && formState.coordinatesLon
        ? { coordinatesLon: +formState.coordinatesLon }
        : {}),
    ...(formState.selectedTaskType === 'location' && formState.radius
        ? { radius: +formState.radius }
        : {}),
    ...(formState.selectedTaskType === 'single-selection' ||
        formState.selectedTaskType === 'multiple-selection'
        ? {
            answers: formState.taskAnswers.map((answer) => ({
                content: { ...answer.translations },
                isCorrect: answer.isCorrect,
                sort: answer.sort,
            })),
        }
        : {}),
    status: saveAsDraft ? 0 : 1,
});
